import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var LineChartDown05 = function LineChartDown05(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m6 10 3.4343 3.4343c.198.198.297.297.4112.3341a.5.5 0 0 0 .309 0c.1142-.0371.2132-.1361.4112-.3341l2.8686-2.8686c.198-.198.297-.297.4112-.3341a.5.5 0 0 1 .309 0c.1142.0371.2132.1361.4112.3341L18 14m4-2c0 5.5228-4.4772 10-10 10S2 17.5228 2 12 6.4772 2 12 2s10 4.4772 10 10"
    })
  }));
};
export default LineChartDown05;